<script lang="ts">
  import { browser } from '$app/environment';
  import { page, updated } from '$app/stores';
  import Button from '$components/elements/Button.svelte';
  import { fly } from 'svelte/transition';

  let reloadCountdown: NodeJS.Timeout | undefined = undefined;
  let secondsLeft = 15;

  const onFinish = () => {
    if (reloadCountdown) {
      clearInterval(reloadCountdown);
    }
    if (browser) {
      window.location.reload();
    }
  };
  const onUpdate = () => {
    if (reloadCountdown) {
      clearInterval(reloadCountdown);
    }
    reloadCountdown = setInterval(() => {
      if (secondsLeft > 0) {
        --secondsLeft;
      } else {
        onFinish();
      }
    }, 1000);
  };

  $: if ($updated || $page.error?.status === 503) {
    onUpdate();
  }
</script>

{#if reloadCountdown}
  <div class="update-modal" in:fly={{ duration: 500, y: -100 }}>
    <div class="update-modal__content">
      <p>Web jsme trochu vylepšili, načteme jej znovu, aby Vám vše fungovalo.</p>
      <p>
        {#if secondsLeft > 0}
          Stránka se automaticky obnoví za
          {#key secondsLeft}
            <span class="counter" in:fly={{ y: -20 }}>
              {secondsLeft}
            </span>
          {/key}
          sekund{secondsLeft === 1 ? 'u' : secondsLeft <= 4 ? 'y' : ''}.
        {:else}
          Stránka se automaticky obnovuje...
        {/if}
      </p>
      <Button on:click={onFinish}>Obnovit nyní</Button>
    </div>
  </div>
{/if}

<style lang="scss">
  .update-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100vw;
    height: calc(100vh + 100px);
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;

    &__content {
      color: $color-blue;
      background-color: $color-white;
      margin-top: -100px;
      padding: 100px;
      border-radius: 10px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 40px;

      p {
        font-size: 1.5rem;
        .counter {
          display: inline-block;
        }
      }
    }
  }
</style>
